import { render, staticRenderFns } from "./ProductSearchResultDetail.vue?vue&type=template&id=4cf77629&scoped=true&"
import script from "./ProductSearchResultDetail.vue?vue&type=script&lang=js&"
export * from "./ProductSearchResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchResultDetail.vue?vue&type=style&index=0&id=4cf77629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf77629",
  null
  
)

component.options.__file = "ProductSearchResultDetail.vue"
export default component.exports